import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { bridge } from '../../../../../utils';

type LogClickFilterParams = {
  selectedItem?: string;
  itemLogging?: AnyObject;
};

export const useLogClickFilter = (logging: AnyObject) => {
  return useCallback(
    ({ selectedItem, itemLogging }: LogClickFilterParams) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_FILTER',
        ably_only_log: {
          ...logging.ably_only_log,
          ...itemLogging?.ably_only_log,
        },
        analytics: {
          ...logging.analytics,
          ...itemLogging?.analytics,
          ...(selectedItem != null && { SELECTED_ITEM: selectedItem }),
        },
      });
    },
    [logging],
  );
};
